import React from 'react'

const Lgbutton = ({btnnlass, btnname}) => {
  // const otherClass = {
  //   padding: ""
  // }

  return (
    <>
      <button style={{background:'hi'}} className={btnnlass}>{btnname}</button>
    </>
  )
}

export default Lgbutton;